import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CheckboxGridRow, GridCellItem } from '../checkbox-grid.model';
import { CheckboxGridService } from './../checkbox-grid.service';

@Component({
  selector: 'checkbox-cell',
  templateUrl: './checkbox-cell.component.html',
  styleUrls: ['./checkbox-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxCellComponent {
  @Input() item: GridCellItem;
  @Input() row: CheckboxGridRow;
  @Input() isReadOnly: {
    value: boolean;
    type: 'icon' | 'text';
    label: any;
  };

  @Output() itemChecked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private checkboxGridService: CheckboxGridService) {}

  handleClick(event) {
    this.item.value = !this.item.value;
    this.itemChecked.emit(this.item);
  }
}
